export enum eModules {
  FACTORY_DASHBOARD = 'factory-dashboard',
  FACTORY_STUDIO = 'factory-studio',
  PERFORMANCE_DASHBOARD = 'performance-dashboard',
  PUBLIC_API_DASHBOARD = 'public-api-dashboard',
  SCHEDULER = 'scheduler',
  WATCHER = 'watcher',
  ALERTS = 'alerts',
  LOGS = 'logs',
  DATA_INTELLIGENCE = 'data-intelligence',
  ECO_SYSTEM_STORE = 'ecosystem-store',
  AI = 'ai',
}

export enum eSchedulerAggregationFunctions {
  STATIC_VALUE = 'static-value',
  COMPLEX_QUERY = 'complex-query',
  LATEST_VALUE = 'latest-value',
  SUM = 'sum',
  AVERAGE = 'avg',
  MIN = 'min',
  MAX = 'max',
}

export const NAVBAR_HEIGHT = 64
